// extracted by mini-css-extract-plugin
module.exports = {"container":"Search_container__2eLkB","loadingTrigger":"Search_loadingTrigger__if0x0"};